import React from 'react';
import {Modal} from "antd";
import MobileCodeInput from "../components/form/MobileCodeInput";
import Utils from "../utils/Utils";
import "./ValidateMobileStyle.less";

class ValidateMobile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			error: "",
			text: "",
			countdown: -1,
			loading: false
		};
	}

	componentDidMount() {
		this.sendMobileCode();
	}

	componentWillUnmount() {
		if (this.state.code.countdown !== -1) {
			this.setState({
				code: {
					countdown: -1
				}
			})
		}
	}

	sendMobileCode() {
		if (this.state.countdown !== -1) {
			Modal.warning({
				content: "操作太频繁，请稍后再试！",
				okText: "确定"
			})
			return;
		}
		const that = this;
		Utils.sendMobileCodeMessage({
			user_mobile: this.props.mobile,
			group_code: this.props.groupCode,
			use_type: "cmc_mob_login",
			captcha_drive: "false"
		}, function (result) {
			console.log(result);
			if (result.data.code === 10000) {
				that.setState({
					countdown: -1,
					text: "短信验证码已发送成功",
					error: ""
				})
				that.codeTimeCountDown();
			} else {
				that.setState({
					countdown: -1,
					error: result.data.message ? result.data.message : "短信验证码发送失败，请稍后重试"
				})
			}
		})
	}

	codeTimeCountDown() {
		let countdown = this.state.countdown;
		if (countdown === -1) {
			countdown = 60;
		} else {
			countdown--;
		}
		this.setState({
			countdown: countdown
		});
		if (countdown !== -1) {
			const that = this;
			setTimeout(function () {
				that.codeTimeCountDown();
			}, 1000);
		}
	}

	handleModalButtonClick(type, event) {
		if (type === "ok") {
			if (this.state.value === "") {
				this.setState({
					error: "请输入短信验证码"
				})
				return;
			}
			this.setState({
				loading: true
			});
			const that = this;
			Utils.postLoginForm({
				captcha_drive: false,
				login_name: this.props.loginName,
				user_mobile: this.props.mobile,
				group_code: this.props.groupCode,
				msg_pwd: this.state.value,
				md5_pwd: Utils.md5Encrypt(this.props.loginPwd),
				login_type: "GcLnPwdCode"
			}, this.props.loginUrl, function (result) {
				switch (result.data.code) {
					case 10000:
					case 20000:
						Utils.loginSuccess(result.data.data.successback)
						break;
					case 99500:
						Modal.error({
							content: result.data.message ? result.data.message : "强制登录超时，请重试！",
							okText: "确定",
							onOk() {
								that.setState({
									loading: false,
									countdown: -1,
									message: "",
									error: ""
								});
							}
						})
						break;
					default:
						Modal.error({
							content: result.data.message ? result.data.message : "强制登录失败，请重试！",
							okText: "确定",
							onOk() {
								that.setState({
									loading: false,
									countdown: -1,
									message: "",
									error: ""
								});
							}
						})
				}
			});
		} else {
			this.props.onCancel();
		}
	}

	handleCodeButtonOnClick() {
		if (this.state.countdown !== -1) {
			Modal.warning({
				content: "操作太频繁，请稍后再试！",
				okText: "确定"
			})
			return;
		}
		this.sendMobileCode();
	}

	handleCodeOnChange(event) {
		let inputValue = event.target.value ? event.target.value.trim() : "";
		let error = "";
		if (!inputValue) {
			error = "请输入短信验证码";
		}
		this.setState({
			error: error,
			value: inputValue
		})
	}

	handleCodeOnBlur(event) {
		let inputValue = event.target.value ? event.target.value.trim() : "";
		if (inputValue === "") {
			this.setState({
				error: "请输入短信验证码",
				value: inputValue
			});
		}
	}

	render() {
		return (
			<Modal wrapClassName="validate-mobile"
				   title="手机短信验证"
				   visible
				   onOk={this.handleModalButtonClick.bind(this, "ok")}
				   okText="验证"
				   confirmLoading={this.state.loading}
				   onCancel={this.handleModalButtonClick.bind(this, "cancel")}
				   cancelText="取消"
			>
				<div>您需要进一步短信验证，短信验证成功后您将执行登录。
					<p>短信已发送至
						<span style={{color: "blue"}}>
							{this.props.mobile.substring(3, 0)}****{this.props.mobile.substring(7)}
						</span>
						请输入验证登录。
					</p>
				</div>
				<MobileCodeInput value={this.state.value}
								 error={this.state.error}
								 message={this.state.text}
								 countdown={this.state.countdown}
								 onChange={this.handleCodeOnChange.bind(this)}
								 onBlur={this.handleCodeOnBlur.bind(this)}
								 sendCode={this.handleCodeButtonOnClick.bind(this)}/>
			</Modal>);
	}
}

export default ValidateMobile;